import { Link } from "@tanstack/react-router";

export function Footer() {
  return (
    <footer className="bg-muted/30 border-t shadow-lg w-full">
      <div className="mx-auto w-full max-w-7xl p-4 py-6 lg:py-8">
        <div className="md:flex md:justify-between">
          <div className="hidden md:flex items-center">
            <img src="/echorai.svg" alt="Echorai" className="size-12" />
            <div className="flex flex-col px-2">
              <span className="text-xl font-semibold tracking-tight bg-linear-to-r from-foreground to-cyan-500 inline-block text-transparent bg-clip-text">
                Echorai
              </span>
              <span className="text-sm text-muted-foreground">Control Your Digital Echo</span>
              <span className="text-xs text-wrap text-muted-foreground">
                Säker borttagning av exponerad personlig data. Verifierade
                raderingar. Full transparens. EU-hostat.
              </span>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-8 sm:gap-6 sm:grid-cols-3">
            <div>
              <h2 className="mb-6 text-sm font-semibold text-foreground uppercase">
                Legalt
              </h2>
              <ul className="text-muted-foreground font-medium">
                <li className="mb-4">
                  <Link to="/policy" className="hover:underline">
                    Integritetspolicy
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h2 className="mb-6 text-sm font-semibold text-foreground uppercase">
                Kontakt
              </h2>
              <ul>
                <li className="mb-4">
                  <a href="mailto:info@echorai.com" className="hover:underline">
                    info@echorai.com
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h2 className="mb-6 text-sm font-semibold text-foreground uppercase">
                Hitta oss på
              </h2>
              <ul>
                <li className="flex mt-4 sm:justify-center sm:mt-0">
                  <a
                    href="https://www.linkedin.com/company/echorai-ab"
                    className="text-muted-foreground hover:text-foreground"
                  >
                    <img src="/linkedin.svg" alt="" aria-hidden="true" className="size-6" />
                    <span className="sr-only">LinkedIn page</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="my-6 border-border sm:mx-auto lg:my-8" />
        <div className="sm:flex sm:items-center sm:justify-between">
          <span className="text-xs text-gray-400 dark:text-gray-500">
            {`© ${new Date().getFullYear()} Echorai AB — Org.nr 5595633107`}
          </span>
        </div>
      </div>
    </footer>
  );
}
